<template>
    <div :class="$style.info_block">
        <BackButton />
        <GameInfoTitle v-bind="props" />
    </div>
</template>

<script lang="ts" setup>
import BackButton from './BackButton.vue'
import GameInfoTitle, { type GameInfoTitleProps } from './GameInfoTitle.vue'

const props = defineProps<GameInfoTitleProps>()
</script>

<style module>
.info_block {
    overflow: hidden;
    display: flex;
    min-width: 0;
    max-width: 100%;
    height: 48px;
    gap: 8px;
}
</style>
